
<h3 mat-dialog-title class="dialog-title">
    Payment Plan
</h3>

<mat-dialog-content class="has-table">
    <lf-payment-plan
        (error)="closeModal()"
        (saved)="paymentPlanCreated()"
        [charges]="paymentPlanCharges"
    ></lf-payment-plan>
</mat-dialog-content>
